import { enableProdMode } from '@angular/core';
import { platformBrowserDynamic } from '@angular/platform-browser-dynamic';

import { AppModule } from './app/app.module';
import { environment } from './environments/environment';
import { initSentry } from './app/core/sentry.setup';

// Initialize Sentry before Angular bootstrap (fail-safe if DSN not configured)
initSentry();

// Angular production mode
if (environment.production) {
  enableProdMode();
}

// Bootstrap Angular app
platformBrowserDynamic()
  .bootstrapModule(AppModule)
  .catch((err) => console.error(err));
